<template>
  <div class="appleauth2">
    <div v-if="!bindingErrorStatus" class="loadingWindowImg">
      <img src="../assets/img/loading.gif" alt=""/>
    </div>
    <div v-if="bindingErrorStatus" class="loadingWindowText">
      <p>{{ $t("bindingErrorMessage") }}</p>
      <p :style="{textDecoration: 'underline', cursor: 'pointer'}" @click="$router.push('/')">{{ $t("returnHome") }}</p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";

export default {
  name: "appleauth2",
  data() {
    return {
      test: false,
      user: ""
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
      "Auth2RequestToken",
    ]),
    ...mapMutations("auth", ["updateErrorMessage"]),
    initiateLogin() {
      const {user} = this
      if (user) {// app登录
        this.Auth2RequestToken({user, type: "Apple"});
      }
    },
    initPageData() {
      const {user} = this.$route.query
      this.user = user;
      this.initiateLogin();
    }
  },
  mounted() {
    this.initPageData()
  },
  watch: {
    $route(to, from) {
      if (to.path === "/apple-auth2") {
        this.initPageData()
      }
    }
  },
  computed: mapState({
    loginModalVisibilityGlobal: (state) => state.navbar.loginModalVisibilityGlobal,
    loggedIn: (state) => state.auth.loggedIn,
    bindingErrorStatus: (state) => state.auth.bindingErrorStatus,
  }),
};
</script>

<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/appleauth2";
</style>



// WEBPACK FOOTER //
// src/view/appleauth2.vue